import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B07InvoicePage } from '../b07-invoice/b07-invoice';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B07cInvoicePaymentPage } from '../b07c-invoice-payment/b07c-invoice-payment';

/**
 * Generated class for the B07aInvoiceInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface invoiceInfo{
  INVOICE_ID: number;
  DATETIME: string;
  GRANDTOTAL: number; 
  REMARKS: string; 
  FINALIZED_FLG: string; 

  INV_CORP_ID: number;  
  CORP_NAME: string;
  ACTION_BY: number;
  USER_ID: number;
  USER_NAME: string;
}

interface invoiceLineInfo{
  INVOICE_LINE_ID: number;
  INVOICE_ID: number;
  CARD_ID: number;
  CARD_NO: number;
  CREDIT_LIMIT: number;
  USED_CREDIT: number;
  CARD_PAYMENT: number;
  TOTAL_CARD_PAYMENT: number;
}

interface invoicePaymentInfo{
  INVOICE_PAYMENT_ID: number;
  INVOICE_ID:number;
  INVOICE_LINE_ID: number;
  CARD_ID: number;
  CARD_PAYMENT: number;
  TOTAL_CARD_PAYMENT: number;
}

@IonicPage()
@Component({
  selector: 'page-b07a-invoice-info',
  templateUrl: 'b07a-invoice-info.html',
})
export class B07aInvoiceInfoPage {

  private todo : FormGroup;
  loading: any;
  Status: any;
  invoiceArr: invoiceInfo[] = [];
  invoiceItems: invoiceInfo[] = [];
  invoiceLineArr: invoiceLineInfo[] = [];
  invoiceLineItems: invoiceLineInfo[] = [];
  invoicePaymentArr: invoicePaymentInfo[] = [];
  invoicePaymentItems: invoicePaymentInfo[] = [];
  invData = {  REMARKS:''
  }
  public errorMessage: any = "";

  invoiceData = { INVOICE_ID:'', DATETIME:'', 
                  GRANDTOTAL:'', REMARKS:'', SUB_TOTAL:'', TAX:'', FINALIZED_FLG:'', 
                  INV_CORP_ID:'', ACTION_BY:'',
  }

  INVOICE_ID:any;
  USER_ID: any;
  taxTotal: any;
  CORP_NAME: any;
  finalizedFlag: any;
  totalCard: any;
  totalPayment: any = 0;
  Balance: any = 0;
  card_arr:any = [];
  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public serviceapi: ServiceApiProvider,
              public loadingCtrl: LoadingController, public alertCtrl : AlertController) {
    this.todo = this.formBuilder.group({
      remark: [''],
      corporate: ['', Validators.required],
    });

    this.INVOICE_ID = this.navParams.get('paramID');    //invoice ID
    this.USER_ID = sessionStorage.getItem('userid');

    let tbl = ["INVOICE"];
    let column = ["INVOICE_ID"];
    let value = [this.INVOICE_ID];
    
    let tblkey = ["INV_CORP_ID", "ACTION_BY"];
    let fktbl = ["CORPORATE", "USER"];
    let fkkey = ["CORP_ID", "USER_ID"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"INVOICE","1","1").then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Records"]);
      if (this.Status == "1"){

        let Records = result["Records"];

        this.invoiceData.INVOICE_ID = Records[0]["INVOICE_ID"];
        this.invoiceData.DATETIME = Records[0]["DATETIME"];
        this.invoiceData.REMARKS = Records[0]["REMARKS"];
        this.invoiceData.SUB_TOTAL = Records[0]["SUB_TOTAL"];
        this.invoiceData.TAX = Records[0]["TAX"];
        this.invoiceData.GRANDTOTAL = Records[0]["GRANDTOTAL"];
        this.invoiceData.FINALIZED_FLG = Records[0]["FINALIZED_FLG"];
        this.invoiceData.INV_CORP_ID = Records[0]["INV_CORP_ID"];
        this.invoiceData.ACTION_BY = Records[0]["ACTION_BY"];
        this.CORP_NAME = Records[0]["CORP_NAME"];

        this.finalizedFlag = this.invoiceData.FINALIZED_FLG;
        this.taxTotal = this.invoiceData.TAX;                                 //get tax amount

        let tbl = ["INVOICE_LINE"];
        let column = ["INVOICE_ID"];
        let value = [this.INVOICE_ID];
        
        let tblkey = ["CARD_ID"];
        let fktbl = ["CARD"];
        let fkkey = ["CARD_ID"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");

        this.serviceapi.readdata(json_data,"INVOICE_LINE","1","1").then((result) => {
            
          this.Status = result["Message"];

          if (this.Status == "1"){
            
            this.totalCard = result["RXData"];
            let Records = result["Records"];
            this.invoiceLineArr = Records;

            for (let i=0; i<=(this.totalCard-1); i++)           //get card payment info for full payment usage
            {
              this.invoiceLineArr[i].TOTAL_CARD_PAYMENT = 0;
              this.invoiceLineArr[i].CARD_PAYMENT = 0;

              let tbl = ["INVOICE_PAYMENT", "INVOICE_PAYMENT",];
              let column = ["CARD_ID", "INVOICE_ID",];
              let value = [this.invoiceLineArr[i].CARD_ID, this.invoiceLineArr[i].INVOICE_ID];
              
              let tblkey = ["No"];
              let fktbl = ["No"];
              let fkkey = ["No"];

              let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
              let mydata = Object.assign(jsonitem);
              let json_data = this.serviceapi.json_readdata(mydata,"1");
              //Push Card ID
              this.card_arr.push((this.invoiceLineArr[i].CARD_ID).toString());
              this.serviceapi.readdata(json_data,"INVOICE_PAYMENT","1","1").then((result) => {
                
                this.Status = result["Message"];
                if (this.Status == "1"){
                  let RxData = result["RXData"];
                  let Records = result["Records"];
                  this.invoicePaymentArr = Records;
                  this.invoiceLineArr[i].TOTAL_CARD_PAYMENT = this.invoicePaymentArr[RxData-1].TOTAL_CARD_PAYMENT;
                  this.totalPayment += +this.invoicePaymentArr[RxData-1].TOTAL_CARD_PAYMENT;
                }
                else {
                  if (this.Status!="4"){
                    this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                  }
                }
                if (i == (this.totalCard-1)){
                  this.Balance = parseFloat(this.invoiceData.GRANDTOTAL) - this.totalPayment;
                }
              }, (err) => {
                this.errorMessage = "Loading Error. Please try again.";

              });
            }
            
            this.invoiceLineItems = this.invoiceLineArr;
            this.loading.dismiss();
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            this.loading.dismiss();
          }
        }, (err) => {
            this.errorMessage = "Loading Error. Please try again.";
            this.loading.dismiss();
        });
        
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B07aInvoiceInfoPage');
  }

  void(){
    
    let confirm = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Are you sure you want to void this invoice? This action cannot be undone.',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
            console.log('Agree clicked');
            for(let i=0;i<(this.totalCard);i++)
            {
              let balance = this.invoiceLineItems[i].CREDIT_LIMIT - this.invoiceLineItems[i].USED_CREDIT;
              let value = {"BALANCE":balance};
              this.serviceapi.updatedata('CARD', 'CARD_ID',this.invoiceLineItems[i].CARD_ID, value).then((result) => {
                let Message = result["Message"];
                console.log(Message);
            });
            }
      
            this.invoiceData.FINALIZED_FLG = 'Void';
            this.updateInvoice(0);
          }
        }
      ]
    });
    confirm.present();
    
  }
  voiddraft(){
    
    let confirm = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Are you sure you want to void this draft invoice? This action cannot be undone.',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
            console.log('Agree clicked');
            
            this.invoiceData.FINALIZED_FLG = 'Void';
            this.updateInvoice(0);
          }
        }
      ]
    });
    confirm.present();
    
  }
  issue(){
    let confirm = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Are you sure you want to issue this invoice? This action cannot be undone.',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
            console.log('Agree clicked');
            this.showLoader();
            /*for(let i=0;i<(this.totalCard);i++)
            {
              let value = {"BALANCE":this.invoiceLineItems[i].CREDIT_LIMIT};
              this.serviceapi.updatedata('CARD', 'CARD_ID',this.invoiceLineItems[i].CARD_ID, value).then((result) => {
                let Message = result["Message"];
                console.log(Message);
            });
            }*/
    
            this.invoiceData.FINALIZED_FLG = 'Issued';
            this.updateInvoice(1);
          }
        }
      ]
    });
    confirm.present();
  }

  updateInvoice(VIEW){
    console.log(VIEW);
    console.log(this.invoiceData);
    this.serviceapi.updatedata('INVOICE', 'INVOICE_ID', this.INVOICE_ID, this.invoiceData).then((result) => {
        
      this.Status = result["Message"];
      if (this.Status == "1"){
        this.loading.dismiss();
        if (VIEW == 1){
          this.serviceapi.printDocument('2',this.INVOICE_ID, 1).then((result) => {     //view report
            let Records = result["Records"];
            window.open(Records, '', 'height=400,width=600');
          });
        }
        this.navCtrl.setRoot(B07InvoicePage);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  fullPayment(){
    let confirm = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Are you sure you want to update this invoice to full payment? This action cannot be undone.',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
            console.log('Agree clicked');
              
            this.showLoader();

            
            let value = this.SUBMIT_JSON(this.INVOICE_ID, this.USER_ID);
            this.serviceapi.invociepaymentdata(value).then((result) => {
              
              this.Status = result["Message"];
              if (this.Status == '1'){
                this.invoiceData.FINALIZED_FLG = 'Completed';
                this.updateInvoice(0);
              }
              else {
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                this.loading.dismiss();
              }
            }, (err) => {
              this.errorMessage = "Loading Error. Please try again.";
              this.loading.dismiss();
            });
          }
        }
      ]
    });
    confirm.present();
  }

  SUBMIT_JSON(INVOICE_ID, USERID)
  {
      let COMPILE_DATA = {
				Param:"",
        INVOICE_ID:"",
        CARD_ID:[],
        INVOICE_LINE_ID:[],
        CARD_PAYMENT:[],
				TOTAL_CARD_PAYMENT:[],
				UserID: ""
      }

      let invoiceLineTotal = (this.invoiceLineArr).length;
      
      for(let i=0;i<invoiceLineTotal;i++)
      {
        let CARD_PAYMENT = 0;
        let TOTAL_CARD_PAYMENT = 0;

        CARD_PAYMENT = +this.invoiceLineArr[i].USED_CREDIT - this.invoiceLineArr[i].TOTAL_CARD_PAYMENT;
        TOTAL_CARD_PAYMENT = this.invoiceLineArr[i].USED_CREDIT;

        COMPILE_DATA.CARD_ID.push(this.invoiceLineArr[i].CARD_ID);
        COMPILE_DATA.INVOICE_LINE_ID.push(this.invoiceLineArr[i].INVOICE_LINE_ID);
        COMPILE_DATA.CARD_PAYMENT.push(CARD_PAYMENT);
        COMPILE_DATA.TOTAL_CARD_PAYMENT.push(TOTAL_CARD_PAYMENT);
      }

      COMPILE_DATA.Param = "2";                         //Param 2 for send array value
      COMPILE_DATA.INVOICE_ID = INVOICE_ID;
      COMPILE_DATA.UserID = USERID;

     return COMPILE_DATA;
  }

  partialPayment(){
    this.navCtrl.push(B07cInvoicePaymentPage, {paramID: this.INVOICE_ID});
  }

  cancel(){
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B07InvoicePage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }

  save()
  {
    this.showLoader();
    this.invData.REMARKS = this.invoiceData.REMARKS;
    this.serviceapi.updatedata('INVOICE', 'INVOICE_ID', this.INVOICE_ID, this.invData).then((result) => {
        
      this.Status = result["Message"];
      if (this.Status == "1"){
        this.loading.dismiss();
      
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }
  printInvoice(){
    this.save();
    let type = 1;
    if (this.invoiceData.FINALIZED_FLG == 'Draft'){         //if draft will print draft
      type = 3;
    }
    else{                                                   //other status will reprint
      type = 2;                                             //issue, partial payment, completed, void
    }
    console.log(type);
    this.serviceapi.printDocument('2',this.INVOICE_ID, type).then((result) => {
      let Records = result["Records"];
      window.open(Records, '', 'height=400,width=600');
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/b07a-invoice-info/b07a-invoice-info.ts